import React, { useState } from 'react';
import { useMaterials } from '../graphql/queries';
import SimpleTable from '../teal-react/components/organisms/SimpleTable';
import { Add, EditOutlined } from '@mui/icons-material';
import { Checkbox, FormControlLabel, IconButton } from '@mui/material';
import SimpleModal from '../teal-react/components/organisms/SimpleModal';
import MaterialForm from '../components/MaterialForm';
import { useAuth } from '../teal-react/utils/token';
import { useDebounce } from '../teal-react/hooks/useDebounce';
import { filterObjectArray } from '../teal-react/utils/helpers';
import { useNavigate } from 'react-router';

const MoreFilters = (props: any) => {
  const { checked, handleChange } = props;
  return (
    <div>
      <FormControlLabel
        label="Show Products in Results"
        control={<Checkbox checked={checked} onChange={handleChange} />}
      />
    </div>
  );
};

const Materials = () => {
  const [showProducts, setShowProducts] = useState(true);
  const [term, setTerm] = useState('');
  const debouncedSearchTerm = useDebounce(term, 200);
  const { data } = useMaterials();
  const [selected, setSelected] = useState<any>(null);
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!data?.material) {
    return null;
  }
  const materials = filterObjectArray(data.material, debouncedSearchTerm, [
    'name',
  ]);

  const columns: any = [
    {
      header: 'Name',
      cell: 'name',
    },
    {
      header: 'Price',
      align: 'right',
    },
    {
      header: 'Density',
      align: 'right',
    },
  ];

  if (showProducts) {
    columns.push({
      header: 'Products',
      cell: (r: any) => {
        const formulas = r.formulas
          .slice()
          .sort((a: any, b: any) => a.formula.name > b.formula.name);
        return (
          <ul>
            {formulas.map((f: any) => (
              <li>
                <a
                  className="alink"
                  onClick={() => navigate(`/products/${f.formula.product?.id}`)}
                >
                  [{f.formula.name}] {f.formula.product.name}
                </a>
              </li>
            ))}
          </ul>
        );
      },
    });
  }

  if (!user?.isRO) {
    columns.push({
      header: '',
      sort: false,
      cell: (r: any) =>
        !user?.isRO ? (
          <span>
            <IconButton onClick={() => setSelected(r)}>
              <EditOutlined color="primary" />
            </IconButton>
          </span>
        ) : null,
    });
  }

  return (
    <>
      <SimpleTable
        header="Materials"
        headeraction={
          !user?.isRO
            ? {
                icon: <Add />,
                onClick: () => {
                  setSelected({
                    name: '',
                  });
                },
              }
            : null
        }
        onFilter={setTerm}
        onFilterPlaceholder="Filter Materials"
        moreFilters={
          <MoreFilters
            checked={showProducts}
            handleChange={(e: any) => setShowProducts(e.target.checked)}
          />
        }
        data={materials}
        row_limit={9999}
        columns={columns}
      />
      {selected ? (
        <SimpleModal open={true} size="md">
          <MaterialForm model={selected} onClose={() => setSelected(null)} />
        </SimpleModal>
      ) : null}
    </>
  );
};

export default Materials;
